import { BaseAPI } from './baseAPI';
import { DocumentOptions } from './options/documentOptions';
import { DocumentRequest } from './request/documentRequest';
import { DocumentResponse } from './response/documentResponse';
import AxiosInstance from './axiosInstanceService';
import { DocumentStatsResponse } from './response/documentStatsResponse';

export class DocumentAPI extends BaseAPI<
  DocumentResponse,
  DocumentOptions,
  DocumentRequest
> {
  constructor() {
    super('Document');
  }

  public GetDocumentImage = (
    id: number | undefined,
    token: string | undefined,
  ) =>
    AxiosInstance.get(
      `${this.controllerPath}/${id}/Download?access_token=${token}`,
    );

  public deleteDocumentWithQureryID = (id: string | number | undefined) =>
    AxiosInstance.delete<DocumentResponse>(`${this.controllerPath}?id=${id}`);

  public CreateFormData = (req: FormData, timeout = 30000) =>
    AxiosInstance.post<DocumentResponse>(`${this.controllerPath}`, req, {
      timeout,
    });

  public LogDownloadV2 = (
    documentId: number | string,
    source: 'web' | 'mobile',
  ) =>
    AxiosInstance.post<void>(`v2/Document/${documentId}/download`, {
      source,
    }) as unknown as Promise<void>;

  public GetStatsV2 = (documentId: number | string, rangeDays: number) =>
    AxiosInstance.get<DocumentStatsResponse>(
      `v2/Document/${documentId}/stats`,
      {
        params: { rangeDays },
      },
    ) as unknown as Promise<DocumentStatsResponse>;

  public GetStatsBatchV2 = (documentIds: number[], rangeDays: number) =>
    AxiosInstance.get<DocumentStatsResponse[]>(`v2/Document/stats`, {
      params: { ids: documentIds.join(','), rangeDays },
    }) as unknown as Promise<DocumentStatsResponse[]>;
}
